const React = require('react');
const ReactDOM = require('react-dom');

const Repository = require('../components/repositories/Repository.jsx');
const Utilities = require('../components/common/editor/Utilities.jsx');

const { withBlockRendering, PageBottomHiddenDraggable, PageTopHiddenDraggable } = require('./utility/BuilderBlock.jsx');

import { InventoryCellContainer } from './blocks/InventoryCell.jsx';
import Name from './utility/Name.jsx';
import BlockUtilities from './utility/Utilities.jsx';

const dropAreaId = 'dropArea';
const bodyTableId = 'bodyTable';

function _EmailBody(props) {
    const [id, setId] = React.useState(undefined);
    React.useEffect(() => setId(new Date().getTime()), []);
    if (!props.serverSide && !id) {
        return null;
    }
    if (props.builder) {
        const pageType = props.configType || props.pageType;
        let columnCount, inventory;
        switch (pageType) {
            case Name.Content.Transactional.InventoryCell:
                columnCount = 1;
                inventory = { data: props.data && props.data.Inventory && props.data.Inventory.length > 0 && props.data.Inventory[0] };
            // Intentional fallthrough
            case Name.Content.InventoryCell:
            case Name.Content.InventoryCellOverride:
                columnCount = columnCount || 3;
                let columnSpacing;
                if (props.parentBlock && props.parentBlock.config) {
                    if (props.parentBlock.config.inventory) {
                        inventory = props.data;
                        if (!inventory || !inventory.data) {
                            inventory = props.parentBlock.config.inventory.find(inv => inv);
                        }
                    }
                    if (props.parentBlock.config.layout) {
                        columnCount = props.parentBlock.config.layout.columnCount || columnCount;
                        if (props.parentBlock.config.layout.columnSpacing) {
                            columnSpacing = props.parentBlock.config.layout.columnSpacing.value;
                        }
                    }
                }
                return (
                    <InventoryCellContainer.Component
                        {...props}
                        columnCount={columnCount}
                        columnSpacing={columnSpacing}
                        data={inventory && inventory.data}
                        editor={true}
                        width={BlockUtilities.columnWidth(columnCount)} />
                )
        }
    }
    const contentConfig = props.contentConfig || {};
    let body = props.onBlockRendering(contentConfig.blocks || [], (d) => {
        const blockProps = { renderMso: props.renderMso };
        if (!d.type) {
            return blockProps;
        }
        switch (d.type.value) {
            case Name.Block.Footer:
                if (Repository.Session.isArtist(props.session) && Repository.Session.getManagerSubscriptionTier(props.session) != Repository.Type.Subscription.Tier.getValue(Repository.Type.Subscription.Tier.ProPlus)) {
                    blockProps.renderWatermark = true;
                }
                break;
            case Name.Block.Inventory.List:
                blockProps.isTransactional = props.isTransactional;
                break;
        }
        return blockProps;
    }, (d) => {
        if (!d.type) {
            return;
        }
        switch (d.type.value) {
            case Name.Block.Inventory.List:
                return { className: 'editable' };
        }
    });
    const bodyProps = { id: bodyTableId };
    if (props.builder) {
        if (props.dragging) {
            if (bodyProps.className) {
                bodyProps.className += ' dragging';
            } else {
                bodyProps.className = 'dragging';
            }
        }
        bodyProps.id = dropAreaId;
        bodyProps.onDragEnter = props.onDragEnter;
        bodyProps.onDragOver = (e) => { if (e) { e.preventDefault() } }
        bodyProps.onDrop = props.onDrop;
        body = (
            <React.Fragment>
                <PageTopHiddenDraggable adjustTop={true} offset={10} onDragEnter={props.onDragEnter} />
                {body}
                <PageBottomHiddenDraggable onDragEnter={props.onDragEnter} />
            </React.Fragment>
        );
    }
    return (
        <table
            align="center"
            border="0"
            cellPadding="0"
            cellSpacing="0"
            height="100%"
            width="100%"
            {...bodyProps}>
            <tbody>
                <tr>
                    <td align="center" id="bodyCell" valign="top">
                        {body}
                    </td>
                </tr>
            </tbody>
        </table>
    );
}
const EmailBody = withBlockRendering(_EmailBody);

function Head(props) {
    let html = `
        body {
            margin: 0 !important;
            min-width: 100% !important;
            padding: 0 !important;
            width: 100% !important;
        }
        p {
            margin: 0;
            padding: 0;
        }
        ::-webkit-scrollbar {
            background-color: #EAEAEA;
            height: 5px;
            width: 5px;
        } 
        ::-webkit-scrollbar-thumb {
            background: darkgrey;
            border-radius: 5px;
        }
    `;
    if (props.styles) {
        html += props.styles;
    }
    const styles = <style dangerouslySetInnerHTML={{ __html: html }} />;
    return (
        <React.Fragment>
            <meta charSet="utf-8" />
            <meta httpEquiv="Content-type" content="text/html; charset=utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
            <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
            {styles}
        </React.Fragment>
    )
}

class Frame extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleFrameDoc = this.handleFrameDoc.bind(this);
    }

    handleFrameDoc(frameDoc) {
        if (this.state.frameDoc) {
            return;
        }
        this.setState({
            frameDoc
        })
    }

    render() {
        const props = this.props;
        return (
            <FrameContainer onFrameDocument={this.handleFrameDoc} head={<Head {...props} />} {...props}>
                <EmailBody frameDoc={this.state.frameDoc} {...props} />
            </FrameContainer>
        );
    }
}

class FrameContainer extends React.Component {
    constructor(props) {
        super(props);

        this._cancelRender = this._cancelRender.bind(this);
        this.renderFrameContent = this.renderFrameContent.bind(this);
    }

    componentDidMount() {
        this.renderFrameContent();
    }

    componentDidUpdate() {
        this.renderFrameContent();
    }

    componentWillUnmount() {
        this._cancelRender();
    }

    _cancelRender() {
        if (this.renderHandle) {
            clearTimeout(this.renderHandle);
            this.renderHandle = null;
        }
    }

    renderFrameContent() {
        if (this.updater && this.updater.isMounted && this.updater.isMounted(this)) {
            const temp = ReactDOM.findDOMNode(this);
            const doc = temp.contentDocument;
            if (doc && doc.readyState === 'complete' && doc.getElementById('frameContent') != null) {
                if (this.props.onFrameDocument) {
                    this.props.onFrameDocument(doc);
                }
                ReactDOM.render(this.props.head, doc.head);
                const contentContainer = doc.getElementById('frameContent');
                if (contentContainer && contentContainer.children && contentContainer.children.length == 0 && this.props.onLoad) {
                    const component = this;
                    setTimeout(function () {
                        component.props.onLoad({ currentTarget: temp });
                    }, 10);
                }
                ReactDOM.render(this.props.children, contentContainer);
                return;
            }
        }
        // Wait for the iframe to be ready
        this._cancelRender();
        this.renderHandle = setTimeout(this.renderFrameContent, 0);
    }

    render() {
        return <iframe id={this.props.id} srcDoc={`<div id='frameContent' class=${this.props.className} />`} style={this.props.style} />;
    }
}

export { EmailBody, Frame, Head, Name, Utilities };